import React, { useMemo, Fragment } from 'react';
import { Modal, Checkbox, Alert } from 'antd';
import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/packageOrderList';
import Button from 'components/ui-ant/Button';

// pageContainer
import PrintSettingsButton from '_pageContainers/oms/PackageOrderList/printSettings/tfs';

import './style.less'

const PrintSettingsButtonGrid = (pageContext) => {
  const {
    saved,
    setSaved,
    modalReady,
    setModalReady,
    selectedFilterAttrs,
    setSelectedFilterAttrs,
    filterAttributes,
    openFiltersModal,
    savePrintSettings,
    handleCheckboxChange,
  } = pageContext;

  let checkedFilterAttributes = selectedFilterAttrs.filter(
    (item) => item.checked
  );

  const setTitle = () => {
    if (selectedFilterAttrs.length) {
      return [
        <span key={1}>{$ST.PRINT_SETTINGS.SETTINGS} </span>,
        <span className='selected-filters-text' key={2}>
          {' '}
          | {$ST.PRINT_SETTINGS.SELECTED_FILTERS}:{' '}
        </span>,
        ...checkedFilterAttributes.map((sf) => (
          <Button className='selected-filter-item' key={sf.label} type='dashed'>
            {sf.label}
          </Button>
        )),
      ];
    } else {
      return <span key={3}>{$ST.PRINT_SETTINGS.SETTINGS}</span>;
    }
  };

  const modalTitle = useMemo(() => {
    return setTitle();
  }, [selectedFilterAttrs]);

  return (
    <Fragment>
      <Button
        type='link'
        disabled={checkedFilterAttributes.length > 8}
        className='print-settings-button'
        onClick={() => openFiltersModal()}
      >
        {$ST.PRINT_SETTINGS.SETTINGS}
      </Button>

      <Modal
        className='print-settings-modal'
        title={modalTitle}
        visible={modalReady}
        width='75%'
        onCancel={() => {
          setModalReady(false);
          setSaved(false);
          setSelectedFilterAttrs(checkedFilterAttributes);
        }}
        okText={$ST.PRINT_SETTINGS.SAVE}
        cancelText={$ST.PRINT_SETTINGS.CANCEL}
        onOk={() => {
          savePrintSettings();
        }}
      >
        {saved && (
          <Alert
            message={$ST.PRINT_SETTINGS.SUCCESS_MESSAGE}
            className='mb-3'
            type='info'
          />
        )}
        {checkedFilterAttributes.length >= 8 && (
          <Alert
            message={$ST.PRINT_SETTINGS.WARNING_MESSAGE}
            className='modal-alert-box'
            type='warning'
          />
        )}
        <div className='filter-wrapper'>
          {filterAttributes.length &&
            filterAttributes.map((filter, index) => {
              const isDisabled =
                checkedFilterAttributes.length >= 8
                  ? !checkedFilterAttributes.find(
                      (item) => item.key === filter.key
                    )
                  : false;
              const checkStatus = filterAttributes.find(
                (selectedFilter) => selectedFilter.label === filter.label
              );

              const defaultChecked = checkStatus && checkStatus.checked;

              return (
                <div className='checkbox-item' key={index}>
                  <Checkbox
                    name={filter.label}
                    defaultChecked={defaultChecked}
                    onChange={(e) => handleCheckboxChange(e, filter.key)}
                    disabled={isDisabled}
                  >
                    {filter.label}
                  </Checkbox>
                </div>
              );
            })}
        </div>
      </Modal>
    </Fragment>
  );
};

export default PrintSettingsButton(PrintSettingsButtonGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderList/printSettings/main/index.js